// @flow
import {MapDrawing} from '../MapDrawing';

import type {CircleEventListener, MapLocation} from '../MapDrawing';

const COLOR_POLYGON_PREVIEW = '#E13065';
const COLOR_POLYGON = '#7B39FF';
export default class GoogleMapsDrawing implements MapDrawing {
  drawMap: () => void;
  drawMarker: (map: any, mapLocation: MapLocation, color: string) => void;
  provider: ?any;
  eventListener: ?any;
  circleEvents: ?(any[]);

  constructor(provider: any) {
    this.provider = provider;
    this.circleEvents = [];
  }

  drawMap = (element: HTMLDivElement, mapLocation: MapLocation) => {
    if (this.provider) {
      return new this.provider.maps.Map(element, {
        center: {
          lat: mapLocation.lat,
          lng: mapLocation.lng,
        },
        zoom: mapLocation ? 13 : 4,
      });
    }
  };

  drawMarker = (
    map: any,
    mapLocation: MapLocation,
    color: string,
    options?: {[key: string]: any}
  ) => {
    const draggable =
      options && options.draggable !== undefined ? options.draggable : true;

    if (this.provider) {
      return new this.provider.maps.Marker({
        map,
        draggable: draggable,
        icon: {
          path:
            'M0 16.2196C0 7.24989 7.23554 0 15.9877 0C24.7645 0 32 7.24989 32 16.2196C32 20.7396 30.4132 24.9359 27.8014 28.4926C24.9201 32.4159 21.3688 35.8341 17.3714 38.5172C16.4565 39.1373 15.6308 39.1841 14.6267 38.5172C10.6066 35.8341 7.05522 32.4159 4.19859 28.4926C1.58491 24.9359 0 20.7396 0 16.2196ZM10.7185 16.7253C10.7185 19.7302 13.0854 22.0935 15.9876 22.0935C18.8917 22.0935 21.2814 19.7302 21.2814 16.7253C21.2814 13.7439 18.8917 11.2655 15.9876 11.2655C13.0854 11.2655 10.7185 13.7439 10.7185 16.7253Z',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new this.provider.maps.Point(16, 40),
          color: color,
          fillColor: color,
        },
        position: {
          lat: mapLocation.lat,
          lng: mapLocation.lng,
        },
      });
    }
  };

  drawCircle = (
    map: any,
    mapLocation: MapLocation,
    radius: number,
    color: string,
    options?: {[key: string]: any}
  ) => {
    const draggable =
      options && options.draggable !== undefined ? options.draggable : false;

    const editable =
      options && options.editable !== undefined ? options.editable : true;

    if (this.provider) {
      return new this.provider.maps.Circle({
        map,
        draggable: draggable,
        editable: editable,
        center: {
          lat: mapLocation.lat,
          lng: mapLocation.lng,
        },
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35,
        radius: radius * 1000,
      });
    }
  };

  drawPolygonPreview = (map: any, path: any) => {
    if (this.provider) {
      const polygon = new this.provider.maps.Polygon({
        paths: path,
        strokeColor: COLOR_POLYGON_PREVIEW,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: COLOR_POLYGON_PREVIEW,
        fillOpacity: 0.35,
      });
      polygon.setMap(map);
      return polygon;
    }
  };

  removePolygon = (polygon: any) => {
    if (this.provider) {
      return polygon.setMap(null);
    }
  };

  setPolygon = (map: any, path: any) => {
    if (this.provider) {
      const polygon = new this.provider.maps.Polygon({
        paths: path,
        strokeColor: COLOR_POLYGON,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: COLOR_POLYGON,
        fillOpacity: 0.35,
      });
      polygon.setMap(map);
      return polygon;
    }
  };

  addMarkerDragendEvent = (markerElement: any, callback: () => void) => {
    this.eventListener = markerElement.addListener('dragend', callback);
  };

  addCircleEvent = (
    circleElement: any,
    eventListener: CircleEventListener,
    callback: () => void
  ) => {
    if (!this.circleEvents) this.circleEvents = [];
    this.circleEvents.push(circleElement.addListener(eventListener, callback));
  };

  getMarkerPosition = (marker: any) => {
    return marker.getPosition();
  };

  centerMapToPosition = (map: any, mapLocation: MapLocation, zoom: number) => {
    map.setCenter({
      lat: mapLocation.lat,
      lng: mapLocation.lng,
    });
    map.setZoom(zoom);
  };
  setMarkerPosition = (
    markerElement: any,
    map: any,
    mapLocation: MapLocation
  ) => {
    const position = {
      lat: mapLocation.lat,
      lng: mapLocation.lng,
    };
    markerElement.setPosition(position);
    this.centerMapToPosition(map, mapLocation, 15);
  };

  cleanUp = (marker: any) => {
    if (this.eventListener && this.provider && this.provider.maps)
      this.provider.maps.event.removeListener(this.eventListener);
    this.eventListener = null;
  };
}
